export default {
  cards: (state) => state.cards,
  allTasks: (state) => state.tasks,
  cardTypes: (state) => state.cardTypes,
  card: (state) => state.card,
  notifications: (state) => state.notifications,
  tenants: (state) => state.tenants,
};
